<div ngbDropdown>
  <button
    type="button"
    class="mr-7 inline-flex items-center p-0 hover:opacity-75"
    [ngbTooltip]="tooltip"
    ngbDropdownToggle
  >
    <span class="nav-link mr-2"><ng-content select="[header]"></ng-content></span>
  </button>
  <ul class="dropdown-menu" ngbDropdownMenu>
    <ng-content select="[items]"></ng-content>
  </ul>
</div>
